/* eslint eslint-comments/no-unlimited-disable: off */
/* eslint-disable */
// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
export var ArrayNDDataType;
(function (ArrayNDDataType) {
    /**
     * boolean
     */
    ArrayNDDataType[ArrayNDDataType["BOOL"] = 0] = "BOOL";
    /**
     * signed integer types
     */
    ArrayNDDataType[ArrayNDDataType["I8"] = 1] = "I8";
    ArrayNDDataType[ArrayNDDataType["I16"] = 2] = "I16";
    ArrayNDDataType[ArrayNDDataType["I32"] = 3] = "I32";
    ArrayNDDataType[ArrayNDDataType["I64"] = 4] = "I64";
    /**
     * unsigned integer types
     */
    ArrayNDDataType[ArrayNDDataType["U8"] = 5] = "U8";
    ArrayNDDataType[ArrayNDDataType["U16"] = 6] = "U16";
    ArrayNDDataType[ArrayNDDataType["U32"] = 7] = "U32";
    ArrayNDDataType[ArrayNDDataType["U64"] = 8] = "U64";
    /**
     * floating-point types
     */
    ArrayNDDataType[ArrayNDDataType["F16"] = 9] = "F16";
    ArrayNDDataType[ArrayNDDataType["F32"] = 10] = "F32";
    ArrayNDDataType[ArrayNDDataType["F64"] = 11] = "F64";
})(ArrayNDDataType || (ArrayNDDataType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXJyYXktbmRkYXRhLXR5cGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbGliL2dlbmVyYXRlZC9mYnMvcnZhaS9hcnJheS1uZGRhdGEtdHlwZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBSyxzREFBc0Q7QUFDdEQsb0JBQW9CO0FBQ3BCLGNBQWM7QUFDbEIscUVBQXFFO0FBRXRFLE1BQU0sQ0FBTixJQUFZLGVBNEJYO0FBNUJELFdBQVksZUFBZTtJQUN6Qjs7T0FFRztJQUNILHFEQUFRLENBQUE7SUFFUjs7T0FFRztJQUNILGlEQUFNLENBQUE7SUFDTixtREFBTyxDQUFBO0lBQ1AsbURBQU8sQ0FBQTtJQUNQLG1EQUFPLENBQUE7SUFFUDs7T0FFRztJQUNILGlEQUFNLENBQUE7SUFDTixtREFBTyxDQUFBO0lBQ1AsbURBQU8sQ0FBQTtJQUNQLG1EQUFPLENBQUE7SUFFUDs7T0FFRztJQUNILG1EQUFPLENBQUE7SUFDUCxvREFBUSxDQUFBO0lBQ1Isb0RBQVEsQ0FBQTtBQUNWLENBQUMsRUE1QlcsZUFBZSxLQUFmLGVBQWUsUUE0QjFCIn0=